import styled from 'styled-components';  
import HrImg from '../../img/hr-maru.png';
import Img2 from '../../../img/vol4b.jpg';
import Img1 from '../../../img/vol4a.png';
const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`

const Vol4: React.VFC = () => {
  return (
    <Main>
         <div className="text-break Blog-comment">
                <p>今回ご紹介するレッスンテーマは『てこ』です。 </p>
                <p>てこと言えば、中学受験の物理分野において主役級の存在ですね。</p>
                <p>低学年の子たちは、てこの原理を理解してくれるかな？と少し心配しつつ、レッスンスタート。</p>
                <p>まず初めに基本事項を説明した後、ブロックで作ったてこの模型を使って、「支点と力点の間の距離が長くなると、小さな力で物体を持ち上げられる」ということを体感してもらいました。</p>
                <p>「あっ！ 全然ちがーう！」「うわっ！ おもっ！」など歓声をあげながら、皆ちゃんと違いをわかってくれました。</p>
                <p>その後、皆の大好きな制作タイム。</p>
                <p>見本を置いてはいるのですが、各自のオリジナリティが出るわ出るわ・・・</p>
                <p>これが醍醐味なんですよね～(*^^*)。</p>
                <p>原理さえ再現してくれれば、デザインや大きさは自由なので、毎回見本とは似ても似つかない作品のオンパレードです。</p>
                <p>↓は、小学３年生の作品です。機動力も備わっていそうなカタパルトですね。</p>
                <div className="card-mokuji">
                    <img width="335" height="251" src={Img1} alt="" />
                </div>
                <p>一方、↓が見本です。いたってシンプルですね(笑)。</p>
                <div className="card-mokuji" >
                    <img width="335" height="251" src={Img2}  alt="" />
                </div>
                <p>こうして比較すると、子どもたちの創意工夫の素晴らしさがよく分かりますよね。しかも、たった30分足らずの間に制作するわけですから、子どもたちの能力は本当に限界知らずだなと感じます。</p>
                <p>制作後は「ピンポン玉をどこまで飛ばせるか」ゲームをしました。</p>
                <p>皆、当然１位狙いなので、一生懸命に改良を重ねてくれました。</p>
                <p>「高さがある方が遠くまで飛びそう！」「腕の部分を長くしたらもっと飛ぶんじゃないかな？」</p>
                <p>「力いっぱい飛ばすには、壊れないように丈夫にしとかないと！」などなど、今回も知らず知らずのうちに物理の学習がしっかり進んでいる様子(^^♪</p>
                <p>受験の王道のてこですが、こんなに楽しく原理を学べるんだなぁと、私自身勉強になったレッスンでした。</p>
            </div>
    </Main>
    
  );
}
export default Vol4;